/* tslint:disable */
/* eslint-disable */
/**
 * Wolf Security Portal Customer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0 (2.0)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PublicDeviceLookup,
  TenantCreation,
  TenantCreationError,
  TenantCreationRequest,
} from '../models';
import {
    PublicDeviceLookupFromJSON,
    PublicDeviceLookupToJSON,
    TenantCreationFromJSON,
    TenantCreationToJSON,
    TenantCreationErrorFromJSON,
    TenantCreationErrorToJSON,
    TenantCreationRequestFromJSON,
    TenantCreationRequestToJSON,
} from '../models';

export interface DeviceAffiliateCreateRequest {
    userFacingId: string;
    tenantCreationRequest: TenantCreationRequest;
}

export interface DeviceRetrieveRequest {
    userFacingId: string;
}

/**
 * 
 */
export class DeviceApi extends runtime.BaseAPI {

    /**
     * Create a new tenant and affiliate the device to it
     */
    async deviceAffiliateCreateRaw(requestParameters: DeviceAffiliateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantCreation>> {
        if (requestParameters.userFacingId === null || requestParameters.userFacingId === undefined) {
            throw new runtime.RequiredError('userFacingId','Required parameter requestParameters.userFacingId was null or undefined when calling deviceAffiliateCreate.');
        }

        if (requestParameters.tenantCreationRequest === null || requestParameters.tenantCreationRequest === undefined) {
            throw new runtime.RequiredError('tenantCreationRequest','Required parameter requestParameters.tenantCreationRequest was null or undefined when calling deviceAffiliateCreate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/device/{user_facing_id}/affiliate/`.replace(`{${"user_facing_id"}}`, encodeURIComponent(String(requestParameters.userFacingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TenantCreationRequestToJSON(requestParameters.tenantCreationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantCreationFromJSON(jsonValue));
    }

    /**
     * Create a new tenant and affiliate the device to it
     */
    async deviceAffiliateCreate(requestParameters: DeviceAffiliateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantCreation> {
        const response = await this.deviceAffiliateCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * A collection of device APIs that are not tenant-specific and are accessible to anyone with an HP ID without needing any further permissions.  Care should be taken with all the methods available here to not return more data than is necessary.
     */
    async deviceRetrieveRaw(requestParameters: DeviceRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PublicDeviceLookup>> {
        if (requestParameters.userFacingId === null || requestParameters.userFacingId === undefined) {
            throw new runtime.RequiredError('userFacingId','Required parameter requestParameters.userFacingId was null or undefined when calling deviceRetrieve.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // tokenAuth authentication
        }

        const response = await this.request({
            path: `/customerapi/v2/device/{user_facing_id}/`.replace(`{${"user_facing_id"}}`, encodeURIComponent(String(requestParameters.userFacingId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PublicDeviceLookupFromJSON(jsonValue));
    }

    /**
     * A collection of device APIs that are not tenant-specific and are accessible to anyone with an HP ID without needing any further permissions.  Care should be taken with all the methods available here to not return more data than is necessary.
     */
    async deviceRetrieve(requestParameters: DeviceRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PublicDeviceLookup> {
        const response = await this.deviceRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
